import { Component, OnDestroy, OnInit } from '@angular/core';
import { Validators, UntypedFormGroup } from '@angular/forms';
import { map, take, takeUntil } from 'rxjs/operators';
import { OrderQuery } from '../../state/order.query';
import { OrderStore } from '../../state/order.store';
import { FormBuilder } from '@angular/forms';
import { sendGAEvent } from '../../../utils/google-analytics';
import { Subject } from 'rxjs';
import { CookieSettingsService } from 'app/core/cookie-settings/cookie-settings.service';
import { NotificationService, NotificationType } from '@core';

@Component({
    selector: 'app-order-success-view',
    templateUrl: './order-success-view.component.html',
    styleUrls: ['./order-success-view.component.scss'],
    standalone: false,
})
export class OrderSuccessViewComponent implements OnDestroy, OnInit {
    public form: UntypedFormGroup;
    public formSubmitted: boolean = false;
    private unsubscribe$: Subject<void> = new Subject();

    public get showForm(): boolean {
        return this.cookieSettingService.cookieManager.getAllowance('google');
    }

    public constructor(
        private readonly formBuilder: FormBuilder,
        private readonly orderQuery: OrderQuery,
        private readonly orderStore: OrderStore,
        private readonly cookieSettingService: CookieSettingsService,
        private readonly notificationService: NotificationService,
    ) {
        this.initForm();
        this.subscribeForFormchange();
    }

    public ngOnInit(): void {
        this.orderQuery.state$.pipe(take(1)).subscribe(() => {
            this.orderStore.reset();
        });
    }

    public ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    public openCookieDialog(): void {
        this.cookieSettingService.showCookieSettingsDialog.set(true);
    }

    public submit(): void {
        const { whereDoYouKnowUsFrom, other } = this.form.value;
        this.form.disable();
        sendGAEvent(
            other ?? whereDoYouKnowUsFrom,
            'sent_whereDoYouKnowUsFrom_form',
            'survey_form',
            (success: boolean) => {
                if (success) {
                    this.notificationService.notify(
                        'Deine Angaben wurden erfolgreich gespeichert',
                        NotificationType.SUCCESS,
                    );
                    this.formSubmitted = true;
                } else {
                    this.notificationService.notify(
                        'Deine Angaben konnten nicht übermittelt werden. Bitte überprüfe Deine Cookie-Einstellungen oder Add-Blocker und versuche es erneut.',
                        NotificationType.WARNING,
                    );
                    this.form.enable();
                }
            },
        );
    }

    private initForm(): void {
        this.form = this.formBuilder.group({
            whereDoYouKnowUsFrom: [null, Validators.required],
            other: ['', [Validators.required, Validators.minLength(3)]],
        });
        this.form.get('other').disable();
    }

    private subscribeForFormchange(): void {
        this.form.valueChanges
            .pipe(
                map((value) => value.whereDoYouKnowUsFrom),
                takeUntil(this.unsubscribe$),
            )
            .subscribe((whereDoYouKnowUsFrom) => {
                if (whereDoYouKnowUsFrom === 'other') {
                    this.form.get('other').enable({ emitEvent: false });
                } else {
                    this.form.get('other').disable({ emitEvent: false });
                }
            });
    }
}
